import { useContext } from 'react';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

export const useFormVisibilityHandler = () => {
    const { userCapabilities } = useContext(AppContext);

    const verifyCondition = (conditiongroup, watch, user) => {
        if (!conditiongroup || typeof conditiongroup !== 'object') {
            return true;
        }
        let visible = true;
        let innerConditions = [];
        Array.isArray(conditiongroup.visibilitycondition) && conditiongroup.visibilitycondition.forEach((rule, k) => {
            if (Array.isArray(rule)) {
                innerConditions.push(verifyInnerRule(rule, watch, user))
            } else {
                innerConditions.push(rule)
            }
        })

        //console.info('innerConditions', innerConditions);
        // if (conditiongroup.name == 'campaign_info' && (conditiongroup.visibilitycondition ?? []).length > 0) {
        //     console.info('qui verifyCondition', conditiongroup, innerConditions);
        // }

        // le condizioni possono essere 
        // a) una sola condizione valutata autonomamente
        // b) tre condizioni con la seconda una stringa 'and'/'or', risolte nei due if dedicati
        // c) N > 1 condizioni, tutte array, risolte in AND
        if (innerConditions.length === 1) {
            visible = innerConditions[0];
        } else if (innerConditions.length === 3 && innerConditions[1] === 'and') {
            //console.debug('verifyCondition 3 innerConditions', conditiongroup.name, conditiongroup.visibilitycondition, innerConditions);
            visible = innerConditions[0] && innerConditions[2];
        } else if (innerConditions.length === 3 && innerConditions[1] === 'or') {
            visible = innerConditions[0] || innerConditions[2];
        } else if (innerConditions.length > 1) {
            // caso con più condizioni, risolte in AND
            visible = innerConditions.every(element => element === true)
        }

        return visible;
    }

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    };

    // eslint-disable-next-line eqeqeq
    const looseEqual = (a, b) => a == b;

    const evaluateOperator = (currentValue, operator, comparisonValue) => {
        switch (operator) {
            case '=':
                return looseEqual(currentValue, comparisonValue);
            case '!=':
            case 'isNot':
                return !looseEqual(currentValue, comparisonValue);
            case 'in':
                return comparisonValue.includes(currentValue);
            case 'nin':
                return !comparisonValue.includes(currentValue);
            case 'isEmpty':
                return !currentValue || currentValue.length === 0;
            case 'isNotEmpty':
                return currentValue && currentValue.length > 0;
            case 'countEquals':
                return (currentValue ?? '').length === parseInt(comparisonValue);
            case 'countLessOrEquals':
                return (currentValue ?? '').length <= parseInt(comparisonValue);
            case 'countMoreOrEquals':
                return (currentValue ?? '').length >= parseInt(comparisonValue);
            case 'countLess':
                return (currentValue ?? '').length < parseInt(comparisonValue);
            case 'countMore':
                return (currentValue ?? '').length > parseInt(comparisonValue);
            default:
                return true;
        }
    };

    const verifyInnerRule = (rule, watch, user) => {
        if (rule[2] === 'null') rule[2] = null

        let currentValue;
        if (rule[0] === 'user.role') {
            currentValue = user.roles[0] ?? null
        } else if (rule[0] === 'user.capability') {
            currentValue = Object.keys(userCapabilities) ?? null
        } else {
            currentValue = watch(rule[0]) ?? null;
        }

        if (currentValue === null && rule[0].includes('.')) {
            const dotIndex = rule[0].indexOf('.');
            const parentField = rule[0].substring(0, dotIndex);
            const childProperty = rule[0].substring(dotIndex + 1);
            const parentValue = watch(parentField);

            if (Array.isArray(parentValue)) {
                return parentValue.some(item => {
                    const itemValue = getNestedValue(item, childProperty) ?? null;
                    return evaluateOperator(itemValue, rule[1], rule[2]);
                });
            }
        }

        return evaluateOperator(currentValue, rule[1], rule[2]);
    }
    return {
        verifyCondition
    }
}